<template>
  <div class="row">

    <div class="col-12 pl-0">
      <h1 class="d-flex align-items-center">
        <span class="icon mr-2 icon-produkte_statistik" aria-hidden="true"></span>
        {{ $t('views.reports.title') }}
      </h1>
    </div>

    <link-back to="/" i18nMessage="common.backToDashboard" />

    <loading-container :state="state">
      <ul v-if="reports.length > 0 || rooms.length > 0" class="reports list-unstyled mx-auto p-inline-start-0">
        <li v-for="(room, index) in rooms" :key="'report-daily-' + index">
          <router-link :to="{ name: 'admin-daily-report', params: { id: room.id }}">{{ $t('views.reports.daily', { msg: room.name}) }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'admin-occupancy-report'}">{{ $t('views.reports.occupancy') }}</router-link>
        </li>
        <li v-for="(report, index) in reports" :key="'report-common-' + index">
          <link-report :report="report" />
        </li>
      </ul>
      <error-message v-else i18nMessage="views.reports.noReports" />
    </loading-container>
  </div>
</template>

<script lang="ts">
import ErrorMessage from '@/components/feedback/ErrorMessage.vue';
import LinkBack from '@/components/interaction/LinkBack.vue';
import LinkReport from '@/components/interaction/LinkReport.vue';
import LoadingContainer from '@/components/structure/LoadingContainer.vue';
import { Room } from '@/generated/openapi';
import LoadingMixin from '@/mixins/LoadingMixin';
import { adminService } from '@/services/adminService';
import { Report, reportService } from '@/services/reportService';
import { LoadingState } from '@/utils/loadingUtils';
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'Reports',
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      reports: [] as Report[],
      rooms: [] as Room[]
    }
  },
  components: {
    LoadingContainer,
    LinkReport,
    ErrorMessage,
    LinkBack,
  },
  created() {
    Promise.all([reportService.getCommonReports(), adminService.getAllRooms()])
      .then(([commonReports, rooms]) => {
        this.reports = commonReports
        this.rooms = rooms
        this.state = LoadingState.success
      }).catch(this.handleErrorWithI18nString)
  }
});
</script>
